import { lazy } from "react"
import { Root } from "src/shared/components"

const CreateDemandNote = lazy(() => import("src/modules/demand-supply-planning/demand-note/pages/CreateDemandNotes"))
const DemandNoteDetails = lazy(() => import("src/modules/demand-supply-planning/demand-note/pages/DemandNotesDetails"))
const DemandNotesList = lazy(() => import("src/modules/demand-supply-planning/demand-note/pages/DemandNotesList"))

const demandSupplyPlanningRoutes = {
  path: "demand-supply-planning",
  element: <Root />,
  children: [
    {
      path: "demand-note",
      children: [
        {
          index: true,
          element: <DemandNotesList />
        },
        {
          path: "create",
          element: <CreateDemandNote />
        },
        {
          path: "details",
          element: <DemandNoteDetails />
        }
      ]
    }
  ]
}

export default demandSupplyPlanningRoutes
